/**
 * Module description...
 *
 * @returns {{init: init}}
 */
const MobileFilters = (() => {

	const DOM = {};
	const cacheDOM = () => {

		DOM.filtersOpen      = document.getElementsByClassName( "product-filters-open" );
		DOM.filtersClose      = document.getElementsByClassName( "product-filters-close" );
		DOM.toggleSidebar      = document.getElementsByClassName( "sidebar" );
		DOM.html					 = document.querySelector( "html" );
	};

	const openFilters = () => {
		DOM.html.classList.add( "filters-open" );
		DOM.filtersOpen[0].classList.add( "open" );
		DOM.toggleSidebar[0].classList.add( "active" );
	}

	const closeFilters = () => {
		DOM.html.classList.remove( "filters-open" );
		DOM.filtersOpen[0].classList.remove( "open" );
		DOM.toggleSidebar[0].classList.remove( "active" );
	}

	const isfiltersOpen = () => {
		return DOM.filtersOpen[0].classList.contains( "open" );
	}

	const toggleFilters = () => {
		if ( ! isfiltersOpen()) {
			openFilters();
		} else {
			closeFilters();
		}
	};

	const eventListeners = () => {

		let addMobileFiltersEventListeners = (windowWidth) => {
			DOM.filtersOpen[0].addEventListener( "click", toggleFilters );
			DOM.filtersClose[0].addEventListener( "click", toggleFilters );
		}

		let windowWidth = document.documentElement.clientWidth;
		closeFilters();
		addMobileFiltersEventListeners( windowWidth );

		window.addEventListener(
			"resize",
			function(){
				windowWidth = document.documentElement.clientWidth;
				closeFilters();
				addMobileFiltersEventListeners( windowWidth );
			}
		);
	};

	const init = () => {
		cacheDOM();
		eventListeners();
	};

	return {
		init,
	};
})();

export default MobileFilters;
